import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { swiperConfig } from '../lib/swiper-config.js';
import { mountEvents } from '../lib/swiper-events.js';

Vue.use(VueAwesomeSwiper);

Vue.component('swiper-col3', {
    data: function () {
        return {
            swiperCol3Options: {
                ...swiperConfig,
                slidesPerView: 1,
                spaceBetween: 25,
                slidesPerGroup: 1,
                loop: false,
                loopFillGroupWithBlank: false,
                breakpoints: {
                    576: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    },
                    992: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    },
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                }
            }
        }
    },
    mounted() {
        mountEvents(this.$el, this.$refs.swiperCol4)
    }
});


